import React from 'react';
import styled from 'styled-components';

import { selectFiles } from '../../core/services/file.service';

interface AddFileProps {
  setFieldValue: (type: string, file: File | null) => void;
  acceptedFiles?: string[];
  errorMessage?: string | null;
  preview?: boolean;
  sourceFile?: string;
  videoSnapShot?: string;
  file?: File | null;
}

export const AddCover: React.FC<AddFileProps> = ({ file, setFieldValue }) => {
  const openFileNavigator = async () => {
    const files = await selectFiles({ accept: 'image/*' });

    if (!files || files.length === 0) {
      return;
    }
    setFieldValue('file', files[0]);
  };

  return (
    <FolderContainer onClick={openFileNavigator}>
      {!file ? (
        <UploadedFileInfo dashed={!file}>
          <Placeholder>Choose a cover</Placeholder>
        </UploadedFileInfo>
      ) : (
        <UploadedFileInfo dashed={!file}>
          {file && <Preview src={URL.createObjectURL(file)} />}
        </UploadedFileInfo>
      )}
    </FolderContainer>
  );
};

const FolderContainer = styled.div`
  height: 100%;
  position: relative;
`;

interface UploadedFileInfoProps {
  dashed?: boolean;
}

const UploadedFileInfo = styled.div<UploadedFileInfoProps>`
  display: flex;
  border-radius: 0.4rem;
  height: 5.6rem;
  cursor: pointer;
  background-color: #367bff33;
  border: ${({ dashed }) => (dashed ? '1px dashed' : '1px solid')};
  border-color: var(--color-primary-crayola);
`;

const Placeholder = styled.div`
  font-size: 1.6rem;
  color: var(--color-primary-crayola);
  font-weight: 400;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-bottom: 0.3rem;
`;

const Preview = styled.img`
  height: 100%;
  object-fit: cover;
  border-radius: 0.8rem;
`;
